import "../../App.css"
import Navbar from '../Navbar/Navbar';
import TopSection from './TopSection/TopSection';
function App() {
  return (
    <div>
      <Navbar />
      <TopSection />
    </div>
  );
}

export default App;
